export class TrackByUtils {
    public static indexOfTrackByProperty(array: any[], objToFind: any, trackBy: string): number {
        for (let i = 0; i < array.length; i++) {
            if (array[i][trackBy] === objToFind[trackBy]) {
                return i;
            }
        }
        return -1;
    }
}